export default "__VITE_ASSET__C7P7$o6S__"